const MCP_BASE = (import.meta.env.VITE_MCP_API_URL as string | undefined) ?? 'http://localhost:3000';

export async function callMcpTool<T = unknown>(
  functionName: string,
  args: Record<string, unknown>,
  clientId: string,
): Promise<T> {
  const resp = await fetch(`${MCP_BASE}/api/tools/call`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ functionName, args, clientId }),
  });
  if (!resp.ok) throw new Error(`MCP ${functionName} failed: HTTP ${resp.status}`);
  const json = await resp.json() as { result?: T; error?: string };
  if (json.error) throw new Error(json.error);
  return json.result as T;
}
